import React from 'react';

import './StatusSummaryDisplay.scss';

class StatusSummaryDisplay extends React.Component {

  state = {
    suspensionStatus:"",
    accessStatus:"",
    terminationStatus:"",
  }

  componentDidMount(){
    const { parker } = this.props;
    this.setState({
      suspensionStatus:parker.fields.suspension_status.value,
      accessStatus:parker.fields.access_system_status.value,
      terminationStatus:parker.fields.termination_status.value,
    })
  }

  render() {
    const { suspensionStatus, accessStatus, terminationStatus } = this.state;
    return (
      <div className='parkchirp--status-summary-display'>
        <div>
          <span className='parkchirp--status-summary-display-title'>
            Suspension Status
          </span>
          <span className='parkchirp--status-summary-value'>
            {suspensionStatus}
          </span>
        </div>
        <div>
          <span className='parkchirp--status-summary-display-title'>
            Access Status
          </span>
          <span className='parkchirp--status-summary-value'>
            {accessStatus}
          </span>
        </div>
        <div>
          <span className='parkchirp--status-summary-display-title'>
            Termination Status
          </span>
          <span className='parkchirp--status-summary-value'>
            {terminationStatus}
          </span>
        </div>
      </div>
    );
  }
}

export default StatusSummaryDisplay;